import ReactGA from 'react-ga4';
import '../../styles/pages/products.scss'

const Wallpapers = () => (
    <>
        <div className="line-container">
            <h1 className="trailer-title">
                Wallpapers
            </h1>
            <div className="le-container" style={{padding: '25px 0px'}}>
                <div className="art-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/img/wallpaper/2560x1600/Zero_Wallpaper_01_2560x1600.webp`} alt="PS4 Legend of Heroes Trails from Zero Packshot" className="art" />
                </div>
                <div className="link-list">
                    <a href={`${process.env.PUBLIC_URL}/img/wallpaper/2560x1600/Zero_Wallpaper_01_2560x1600.webp`} download>
                        <button className="ps-button" onClick={
                            ()=>{
                                ReactGA.event({
                                category: 'Media',
                                action: 'Download',
                                label: `Zero_Wallpaper_01_2560x1600`
                            })}
                        }>
                            2560x1600
                        </button>
                    </a>
                    <a href={`${process.env.PUBLIC_URL}/img/wallpaper/3840x2160/Zero_Wallpaper_01_3840x2160.webp`} download>
                        <button className="ps-button" onClick={
                            ()=>{
                                ReactGA.event({
                                category: 'Media',
                                action: 'Download',
                                label: `Zero_Wallpaper_01_3840x2160`
                            })}
                        }>
                            3840x2160
                        </button>
                    </a>
                    <a href={`${process.env.PUBLIC_URL}/img/wallpaper/Mobile/Zero_Wallpaper_01_Mobile.webp`} download>
                        <button className="ps-button" onClick={
                            ()=>{
                                ReactGA.event({
                                category: 'Media',
                                action: 'Download',
                                label: `Zero_Wallpaper_01_Mobile`
                            })}
                        }>
                            Mobile
                        </button>
                    </a>                
                </div>
            </div>
        </div>
        <div className="le-container" style={{padding: '25px 0px'}}>
            <div className="art-wrapper">
                <img src={`${process.env.PUBLIC_URL}/img/wallpaper/2560x1600/Zero_Wallpaper_02_2560x1600.webp`} alt="PS4 Legend of Heroes Trails from Zero Packshot" className="art" />
            </div>
            <div className="link-list">
                <a href={`${process.env.PUBLIC_URL}/img/wallpaper/2560x1600/Zero_Wallpaper_02_2560x1600.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Wallpaper_02_2560x1600`
                        })}
                    }>
                        2560x1600
                    </button>
                </a>
                <a href={`${process.env.PUBLIC_URL}/img/wallpaper/3840x2160/Zero_Wallpaper_02_3840x2160.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Wallpaper_02_3840x2160`
                        })}
                    }>
                        3840x2160
                    </button>
                </a>
                <a href={`${process.env.PUBLIC_URL}/img/wallpaper/Mobile/Zero_Wallpaper_02_Mobile.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Wallpaper_02_Mobile`
                        })}
                    }>
                        Mobile
                    </button>
                </a>                
            </div>
        </div>
        <div className="le-container" style={{padding: '25px 0px'}}>
            <div className="art-wrapper">
                <img src={`${process.env.PUBLIC_URL}/img/wallpaper/2560x1600/Zero_Wallpaper_03_2560x1600.webp`} alt="PS4 Legend of Heroes Trails from Zero Packshot" className="art" />
            </div>
            <div className="link-list">
                <a href={`${process.env.PUBLIC_URL}/img/wallpaper/2560x1600/Zero_Wallpaper_03_2560x1600.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Wallpaper_03_2560x1600`
                        })}
                    }>
                        2560x1600
                    </button>
                </a>
                <a href={`${process.env.PUBLIC_URL}/img/wallpaper/3840x2160/Zero_Wallpaper_03_3840x2160.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Wallpaper_03_3840x2160`
                        })}
                    }>
                        3840x2160
                    </button>
                </a>
                <a href={`${process.env.PUBLIC_URL}/img/wallpaper/Mobile/Zero_Wallpaper_03_Mobile.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Wallpaper_03_Mobile`
                        })}
                    }>
                        Mobile
                    </button>
                </a>                
            </div>
        </div>
        <h1 className="trailer-title">
            Avatars
        </h1>
        <div className="avatar-list">
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Arios.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Arios.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Arios`
                        })}
                    }>
                        Arios Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Cecile.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Cecile.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Cecile`
                        })}
                    }>
                        Cecile Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Elie.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Elie.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Elie`
                        })}
                    }>
                        Elie Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Fran.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Fran.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Fran`
                        })}
                    }>
                        Fran Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Ilya.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Ilya.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Ilya`
                        })}
                    }>
                        Ilya Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_KeA.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_KeA.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_KeA`
                        })}
                    }>
                        KeA Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Lloyd.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Lloyd.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Lloyd`
                        })}
                    }>
                        Lloyd Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Noel.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Noel.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Noel`
                        })}
                    }>
                        Noel Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Randy.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Randy.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Randy`
                        })}
                    }>
                        Randy Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Rixia.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Rixia.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Rixia`
                        })}
                    }>
                        Rixia Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Sergei.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Sergei.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Sergei`
                        })}
                    }>
                        Sergei Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Tio.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Tio.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Tio`
                        })}
                    }>
                        Tio Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Wald.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Wald.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Wald`
                        })}
                    }>
                        Wald Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Wazy.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Wazy.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Wazy`
                        })}
                    }>
                        Wazy Avatar Download
                    </button>
                </a>   
            </div>
            <div className="avatar-pair">
                <img src={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Zeit.webp`} alt="" />
                <a href={`${process.env.PUBLIC_URL}/img/avatars/Zero_Avatar_Zeit.webp`} download>
                    <button className="ps-button" onClick={
                        ()=>{
                            ReactGA.event({
                            category: 'Media',
                            action: 'Download',
                            label: `Zero_Avatar_Zeit`
                        })}
                    }>
                        Zeit Avatar Download
                    </button>
                </a>   
            </div>
        </div>
    </>
)

export default Wallpapers;